import { Alert, AlertTitle, Typography } from '@mui/material';
import { isNotNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import { commentEnabledModes, DetailStatusProps, noAgreementStatus } from '../NegotiationCaseDetailStatusWidget.types';
import { I18nNamespace } from '~/common/types';
import { Multiline } from '~/components/Multiline';
import { useSupplierComment } from '~/hooks';

export const NoAgreementReachedStatus = ({
  negotiationCaseStatus,
  negotiatedQuote,
  supplierInteractionMode,
}: DetailStatusProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'NegotiationCaseDetailStatusWidget' });
  const { format } = useSupplierComment();
  const comment = format(negotiatedQuote?.supplierComment);
  const commentEnabled = supplierInteractionMode && commentEnabledModes.includes(supplierInteractionMode);
  const hasLineItemComments = negotiatedQuote?.lineItems?.some((item) => item.supplierComment);
  const hasComments = isNotNil(comment) || hasLineItemComments;

  let title = t('noAgreement.title');
  if (commentEnabled && hasComments) {
    title = hasLineItemComments ? t('noAgreement.titleWithItemComments') : t('noAgreement.titleWithComment');
  }

  if (noAgreementStatus.includes(negotiationCaseStatus)) {
    return (
      <Alert severity="error">
        <AlertTitle>{title}</AlertTitle>
        <>
          {commentEnabled && isNotNil(comment) && (
            <Typography variant="body2">
              <Multiline>
                {t('noAgreement.comment', {
                  comment,
                })}
              </Multiline>
            </Typography>
          )}
        </>
      </Alert>
    );
  }

  return null;
};
